import { Separator } from "@/components/ui/Separator";
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "@/components/ui/Sheet";

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/Select";

import {
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
} from "@/components/ui/Command";

import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/Popover";

import { Check, ChevronDown } from "lucide-react";
import { Button } from "@/components/ui/Button";
import React, { useState } from "react";
import { cn } from "@/lib/utils";
import { FloatingLabelInput } from "@/components/ui/floating-lable/Floating";
import { MultiSelect } from "../multiselect/MultiSelectCheckBox";
import { DatePickerWithRange } from "../date-range/DateRangePicker";
import { toast } from "../UseToast";
import { TimeOperatorSelector } from "./TimeOperatorSelector";
import { InputTags } from "../input-tags/Tags";
import { GroupSearchDropdown } from "../group-search-dropdown";
import { PathDropdown } from "../PathDropdown";

interface filtertypes {
  isOpen: boolean;
  setOpen: any;
  initialValue?: any;
  setFilter?: any;
  setSearchCriteria?: any;
  filterData?: any;
  filterDisplay?: any;
  setInputValue: React.Dispatch<React.SetStateAction<string>>;
  setSelectedValues?:React.Dispatch<React.SetStateAction<{ [key: string]: string[] }>>;
}

const TableFilters = ({
  isOpen,
  setOpen,
  initialValue,
  filterData,
  setFilter,
  setSearchCriteria,
  filterDisplay,
  setInputValue,
  setSelectedValues
}: filtertypes) => {
  return (
    <div>
      <Sheet open={isOpen} onOpenChange={() => setOpen(false)}>
        <SheetContent className="!h-screen">
          <SheetHeader>
            <SheetTitle>Filters</SheetTitle>
          </SheetHeader>
          <Separator className=" h-[1px] rounded-full my-2" />
          <div className="py-2 space-y-4 ">
            {filterDisplay &&
              filterDisplay?.map((element: any, i: number) => {
                if (element.type == "select") {
                  return (
                    <Select
                      key={i}
                      name={element.name}
                      value={filterData[element.name]}
                      onValueChange={(value) => {
                        element.function(value);
                      }}
                    >
                      <SelectTrigger
                        className="capitalize w-full"
                        floatingLabel={element.label}
                      >
                        <SelectValue placeholder={"Select " + element.label} />
                      </SelectTrigger>
                      <SelectContent className="capitalize">
                        {element.options?.map((st: any, index: number) => (
                          <SelectItem key={index} value={String(st.value)}>
                            {st.label}
                          </SelectItem>
                        ))}
                      </SelectContent>
                    </Select>
                  );
                }
                if (element.type == "combobox") {
                  return (
                    <div
                      key={i}
                    >
                      <Combobox
                        defaultValue={filterData[element.name]}
                        setFilter={element.function}
                        list={element.options}
                        name={element.name}
                        label={element.label}
                      />
                    </div>
                  );
                }
                if (element.type == "date-range") {
                  return (
                    <div
                      className="w-full " key={element.name}>
                      <DatePickerWithRange
                        name={element.name}
                        value={{
                          date_From: filterData.date_from, // Access date_from directly
                          date_to: filterData.date_to, // Access date_to directly
                        }}
                        onValueChange={(dates) => {
                          // Call your updated function
                          element.function(dates);
                        }}
                        label={"Select " + element.label}
                        className="w-full" // Ensure full width
                      />
                    </div>
                  );
                }

                if (element.type == "percentage") {
                  return (
                    <div
                      key={i}
                    >

                      <FloatingLabelInput
                        type={"number"}
                        min={0}
                        defaultValue={filterData[element.name]}
                        max={100}
                        name={element.name}
                        label={element.label}
                        onChange={element.function}
                        onInput={(e) => {
                          const target = e.target as HTMLInputElement;
                          if (Number(target.value) > 100) {
                            target.value = "100";
                          }
                        }}
                      />
                    </div>
                  );
                }
                if (element.type == "number") {
                  return (
                    <div
                      key={i}
                    >

                      <FloatingLabelInput
                        defaultValue={filterData[element.name]}
                        type={"number"}
                        min={0}
                        id={element.name}
                        name={element.name}
                        label={element.label}
                        onChange={element.function}
                      />
                    </div>
                  );
                }

                if (element.type === "multiselect") {
                  return (
                    <div key={i}>
                      {/* Display selected labels if available
                      {element.selectedValues?.length > 0 && (
                        <div className="mb-2 text-sm text-gray-600">
                          Selected:{" "}
                          <span className="font-medium">
                            {element.selectedValues.join(", ")}
                          </span>
                        </div>
                      )} */}
                      <MultiSelect
                        floatingLabel={element.label.replace(/_/g, " ")}
                        key={element.label}
                        options={element.options}
                        defaultValue={filterData[element.name] || []} // Ensure defaultValue is always an array
                        onValueChange={(selectedValues) => {
                          element.function(selectedValues); // Pass selected values to state handler
                        }}
                        SetSearchCriteria={element.setSearchCriteria}
                        placeholder={
                          "Select " + element.label.replace(/_/g, " ")
                        }
                        variant="inverted"
                        maxCount={1}
                        className="capitalize border-checkboxborder border-[1px]"
                      />
                    </div>
                  );
                }

                if (element.type === "time_opt") {
                  return (
                    <TimeOperatorSelector
                      key={element.name}
                      name={element.name}
                      label={element.label}
                      value={element.defaultValue}
                      options={element.options}
                      onChange={(value) => {

                        element.function(value); // Update the filter state
                      }}
                    />
                  );
                }

                if (element.type === "tags") {
                  return (
                    <div key={i} className="space-y-1">
                      <label className="text-sm font-medium capitalize">
                        {element.label || "Tags"}
                      </label>
                      <InputTags
                        value={filterData[element.name] || []}
                        onChange={(tags) => {
                          // Update the filterData with the new tags
                          setFilter((prev: any) => ({
                            ...prev,
                            [element.name]: tags
                          }));
                          
                          // If there's a specific function to handle tags changes
                          if (typeof element.function === 'function') {
                            element.function(tags);
                          }
                        }}
                        placeholder={element.placeholder || "Enter tags..."}
                        className="min-h-8"
                      />
                    </div>
                  );
                }
                if (element.type === "grouped-search-dropdown") {
                  return (
                    <GroupSearchDropdown
                      value={filterData[element.name] || null}
                      onChange={(val) => {
                        // Update the filterData with the new tags
                        setFilter((prev: any) => ({
                          ...prev,
                          [element.name]: val
                        }));
                        
                        // If there's a specific function to handle tags changes
                        if (typeof element.function === 'function') {
                          element.function(val);
                        }
                      }}
                      groups={element.options}
                      itemToValue={(tag) => String(tag.id)}
                      label={element.label}
                      placeholder={`Select ${element.label}`}
                      searchPlaceholder={`Search ${element.label}...`}
                      noResultsText={`No ${element.label} found`}
                      className="border border-checkboxborder rounded-md"
                      placeholderClassname={"text-gray-800 text-sm"}
                      multiple
                    />
                  )
                }
                if (element.type === "path-dropdown") {
                  return (
                    <PathDropdown
                      value={filterData[element.name] || null}
                      onChange={(val) => {
                        // Update the filterData with the new tags
                        setFilter((prev: any) => ({
                          ...prev,
                          [element.name]: val
                        }));
                        
                        // If there's a specific function to handle tags changes
                        if (typeof element.function === 'function') {
                          element.function(val);
                        }
                      }}
                      groups={element.options}
                      label={element.label}
                      placeholder={`Select ${element.label}`}
                      searchPlaceholder={`Search ${element.label}...`}
                      noResultsText={`No ${element.label} found`}
                      className="border border-checkboxborder rounded-md"
                      placeholderClassname={"text-gray-800 text-sm"}
                      multiple
                      onlyLeafServices={false}
                    />
                  )
                }
              })}
            <div className="gap-3 flex ">
              <Button
                type="submit"
                variant={"outline"}
                onClick={() => {
                  setFilter({});
                  setSearchCriteria({ ...initialValue });
                  setInputValue("");
                  setOpen(false);
                  setSelectedValues?.({})
                }}
                className="border-primary  text-black gap-1 font-semibold w-full"
              >
                Reset
              </Button>
              <Button
                type="submit"
                onClick={() => {
                  const dateRangeFilter = filterDisplay?.find(
                    (element: any) => element.type == "date-range"
                  );

                  let isValidDateRange = true; // To track the validity of the date range

                  if (dateRangeFilter) {
                    const { date_from, date_to } = filterData;

                    // If one date is present and the other is missing, show the error toast
                    if ((date_from && !date_to) || (!date_from && date_to)) {
                      toast({
                        variant: "destructive",
                        description: "Must be a valid date range.",
                      });
                      isValidDateRange = false; // Set to false if invalid
                      return;
                    }

                    // If both dates are missing, log the message and skip applying the date range
                    if (!date_from && !date_to) {
                      isValidDateRange = false; // Set to false if no date range is provided
                    }
                  }

                  // Proceed with applying other filters regardless of the date range validity
                  setSearchCriteria((prev: any) => ({
                    ...prev,
                    ...filterData, // Apply all filter data
                    ...(isValidDateRange
                      ? {}
                      : { date_from: undefined, date_to: undefined }), // Only apply date range if valid
                    offset: 0,
                    sort_key: "id",
                    sort_order: "desc",
                  }));

                  // Close the side panel after applying filters
                  setOpen(false);
                }}
                className="bg-primary text-black space-x-2 font-semibold w-full"
              >
                <i className="fa fa-filter "></i>
                Apply filters
              </Button>
            </div>
          </div>
        </SheetContent>
      </Sheet>
    </div>
  );
};

interface ComboboxType {
  list?: {
    label: string;
    value: string;
  }[];
  defaultValue?: string;
  setFilter?: any;
  name?: string;
  label?: string;
}

function Combobox({
  list,
  setFilter,
  name,
  defaultValue,
  label,
}: ComboboxType) {
  const [open, setOpen] = useState(false);
  const [value, setValue] = useState(
    list?.find((list) => list.value == defaultValue)?.label ?? ""
  );
  return (
    <Popover open={open} onOpenChange={setOpen} modal={true}>
      <PopoverTrigger asChild>
        <div className="relative">
          <span className="absolute p-0 text-[11px] left-2 -top-1.5 px-1 bg-white capitalize">
            {label}
          </span>
          <Button
            variant="outline"
            role="combobox"
            aria-expanded={open}
            className="border-[1px] hover:bg-transparent w-full justify-between font-normal capitalize"
          >
            {value
              ? list && list?.find((list) => list.label == value)?.label
              : "Select " + label?.toLowerCase()}
            <ChevronDown className="ml-2 h-4 w-4 shrink-0 opacity-50" />
          </Button>
        </div>
      </PopoverTrigger>
      <PopoverContent className="w-[330px] max-h-28 p-0" side="bottom">
        <Command>
          <CommandInput placeholder={`Search ${label}`} />
          <CommandEmpty>No list found.</CommandEmpty>
          <CommandList className="custom-scrollbar">
            <CommandGroup>
              {list &&
                list?.map((item) => (
                  <CommandItem
                    className="capitalize"
                    key={item.value}
                    value={item.value}
                    onSelect={(currentValue) => {
                      setValue(currentValue == value ? "" : currentValue);
                      setFilter(
                        list &&
                        list?.find((list) => list.label === currentValue)
                          ?.value
                      );
                      setOpen(false);
                    }}
                  >
                    <Check
                      className={cn(
                        "mr-2 h-4 w-4",
                        value === item.label ? "opacity-100" : "opacity-0"
                      )}
                    />
                    {item.label}
                  </CommandItem>
                ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
}

export default TableFilters;
